import { render, staticRenderFns } from "./BudgetSimulator.vue?vue&type=template&id=796288d4&"
import script from "./BudgetSimulator.vue?vue&type=script&lang=js&"
export * from "./BudgetSimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports